const BASE_API = `${process.env.REACT_APP_API}/v${process.env.REACT_APP_API_VERSION}`;

export const UrlPaths = {
  DASHBOARD: '/dashboard',
  AGENDA: '/dashboard/agenda',
  CUSTOMERS: '/dashboard/clientes',
  CONSIGNMENT_ORDER: '/dashboard/ordenes-de-consigna',
  CONSIGNMENT_ORDER_BILLING: (id, numberOrder) =>
    `/dashboard/factura-de-consigna/${id}/${numberOrder}`,
  CONSIGNMENT_ORDER_BILLING_CREATE: (id, numberOrder) =>
    `/dashboard/factura-de-consigna/${id}/${numberOrder}/crear`,
  CONSIGNMENT_ORDER_BILLING_DELETE: (path, id) => `${path}/${id}/delete`,
  CONSIGNMENT_ORDER_REFUND: (id, numberOrder) =>
    `/dashboard/devolucion-de-consigna/${id}/${numberOrder}`,
  CONSIGNMENT_ORDER_REFUND_CREATE: (id, numberOrder) =>
    `/dashboard/devolucion-de-consigna/${id}/${numberOrder}/crear`,
  CONSIGNMENT_ORDER_BILLING_EDIT: (consignmentOrderId, numberOrder, id) =>
    `/dashboard/factura-de-consigna/${consignmentOrderId}/${numberOrder}/${id}`,
  CONSIGNMENT_ORDER_REFUND_EDIT: (consignmentOrderId, numberOrder, id) =>
    `/dashboard/devolucion-de-consigna/${consignmentOrderId}/${numberOrder}/${id}`,
  DAILY_CASH_CLOSING_TICKET: (id) =>
    `${BASE_API}/daily-cash-closing/${id}/ticket`,
  DAILY_CASH_CLOSING_CASH_TICKET: (id) =>
    `${BASE_API}/daily-cash-closing-cash/${id}/ticket`,
};
